import { Injectable } from '@angular/core';
import { SearchBoxIssueItem } from '@models/search-box-issue-item';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/state/app-state';
import { MarketType } from 'src/solace';

@Injectable()
export class SearchService {
  public issues: SearchBoxIssueItem[] = [];

  private loggedInSubscription: Subscription;

  constructor(private store: Store<AppState>) {
    this.init();
  }

  public filterData(filterString: string): SearchBoxIssueItem[] {
    return this.issues
      ? this.issues.filter((item: SearchBoxIssueItem) => {
          return item.issue.indexOf(filterString) !== -1;
        })
      : [];
  }

  public filterDataByMarket(
    filterString: string,
    marketType: MarketType,
  ): SearchBoxIssueItem[] {
    return this.issues
      ? this.issues.filter((item: SearchBoxIssueItem) => {
          return (
            item.instrumentType === marketType &&
            item.issue.toLocaleUpperCase().indexOf(filterString) !== -1
          );
        })
      : [];
  }

  public findDataBy(
    value: any,
    filter: keyof SearchBoxIssueItem,
  ): SearchBoxIssueItem {
    return (
      this.issues.find((item) => item[filter] === value) ||
      ({} as SearchBoxIssueItem)
    );
  }

  private init(): void {
    this.loggedInSubscription = this.store
      .select('loggedIn')
      .subscribe((value: boolean) => {
        if (!value) {
          this.issues.length = 0;
        }
      });
  }
}
